const blazeOrange = '#ff6d01';
const claret = '#741b47';
const cornflowerBlue = '#6D9EEB';
const cucumber = '#6AA84F';
const gold = '#BF9000';
const guardsmanRed = '#CC0000';
const black = '#000';
const magenta = '#ff00ff';
const green = '#00FF00';
const darkred = '#5b0f00';

const firstCategory = {
  color: blazeOrange,
  category: [
    'Jams and marmelades',
    'Dried fruits and vegetables',
    'Fresh fruits and vegetables',
    'Pickled fruits and vegetables',
    'Legumes(beans, lents...etc.)',
    'Mushrooms',
    'Fruit syrups and lemonade',
  ],
};

const secondCategory = {
  color: claret,
  category: [
    'Cakes and sweets',
    'Puddings',
    'Chocolate',
    'Ice creams',
    'Bakery products and pastry',
  ],
};

const thirdCategory = {
  color: cornflowerBlue,
  category: [
    'Diary products(butter, cheese, milk, yogurt...etc.)',
    'Honey',
    'Oils',
    'Eggs',
  ],
};

const fourthCategory = {
  color: cucumber,
  category: [
    'Grains',
    'Seeds, cereals and nuts',
    'Spices and Seasonings',
    'Tea and herbal tea',
    'Herbs',
    'Herbal syrups and lemonade',
  ],
};

const fifthCategory = {
  color: gold,
  category: ['Smoked meats, hams and sausages', 'Pesto, sauce and dressings'],
};

const sixthCategory = {
  color: guardsmanRed,
  category: ['Beer, vino and destillate'],
};

const seventhCategory = {
  color: black,
  category: ['Ready meals'],
};

const eightCategory = {
  color: black,
  category: [
    'Appetizers',
    'Bread spread',
    'Pasta',
    'Pizza and focaccia',
    'Fish, sea fruit and shellfish',
    'Meat, steaks and venison',
    'Steamed food',
    'Grilled and charcoaled food',
    'Roasted food',
    'Salads',
    'Soups',
  ],
};

const ninthCategory = {
  color: magenta,
  category: ['Home made natural products', 'Home made tinctures'],
};

const tenthCategory = { color: green, category: ['Experience'] };
const eleventhCategory = { color: darkred, category: ['Pet food'] };

export const CategoryList = [
  firstCategory,
  secondCategory,
  thirdCategory,
  fourthCategory,
  fifthCategory,
  sixthCategory,
  seventhCategory,
  eightCategory,
  ninthCategory,
  tenthCategory,
  eleventhCategory,
];
